import { optionsMap } from 'pro-gallery-lib';
export const FULLSCREEN = {
  ALLOW_TITLE: 'controllers_fullscreen_allowTitleExpand',
  ALLOW_DESCRIPTION: 'controllers_fullscreen_allowDescriptionExpand',
  ALLOW_LINK: 'controllers_fullscreen_allowLinkExpand',
  WHEN_TO_SHOW_INFO: 'controllers_fullscreen_whenToShowInfo',
  EXPAND_INFO_POSITION: 'controllers_fullscreen_expandInfoPosition',
  SHOW_INFO_BUTTON: 'controllers_fullscreen_showInfoExpandButton',
  ALLOW_FULLSCREEN_EXPAND: 'controllers_fullscreen_allowFullscreenExpand',
  LOOP: 'controllers_fullscreen_fullscreenLoop',
  ALLOW_MAGNIFY_IMAGE: 'controllers_fullscreen_allowFullscreenMagnifyImage',
  MAGNIFICATION_LEVEL: 'controllers_fullscreen_fullscreenMagnificationLevel',
  MAGNIFICATION_PERCENT: 'controllers_fullscreen_fullscreenMagnificationPercent',
  BACKGROUND_BLUR_FILTER: 'controllers_fullscreen_backgroundBlurFilter',
  BACKGROUND_GRAYSCAL_EFILTER: 'controllers_fullscreen_backgroundGrayscaleFilter',
  FULLSCREEN_PREVIEW: 'FULLSCREEN_PREVIEW',
  FULLSCREEN_ITEM_CLICK: 'controllers_fullscreen_itemClick',
  FULLSCREEN_CTA: 'FULLSCREEN_CTA'
};
export const FULLSCREEN_CONTROLLERS = {
  [FULLSCREEN.WHEN_TO_SHOW_INFO]: value => {
    const shouldToggleInfo = value === 'ON_TOGGLE';
    return {
      [FULLSCREEN.SHOW_INFO_BUTTON]: shouldToggleInfo,
      defaultShowInfoExpand: !shouldToggleInfo
    };
  },
  [FULLSCREEN.MAGNIFICATION_PERCENT]: value => {
    const magnificationLevel = value / 100;
    return {
      [FULLSCREEN.MAGNIFICATION_LEVEL]: magnificationLevel
    };
  },
  [optionsMap.behaviourParams.item.clickAction]: value => {
    return {
      [FULLSCREEN.FULLSCREEN_ITEM_CLICK]: value.toLowerCase()
    };
  }
};
export const FULLSCREEN_CONTROLLERS_DATA = {
  [FULLSCREEN.ALLOW_TITLE]: {
    key: FULLSCREEN.ALLOW_TITLE,
    title: 'Native_ProGallery_Expand_InfoSettings_WhatInfo_Title',
    type: 'BOOLEAN',
    default: true,
    noBottomDivider: true,
    textLabel: 'Native_ProGallery_Expand_InfoSettings_WhatInfo_Label'
  },
  [FULLSCREEN.ALLOW_DESCRIPTION]: {
    key: FULLSCREEN.ALLOW_DESCRIPTION,
    title: 'Native_ProGallery_Expand_InfoSettings_WhatInfo_Description',
    type: 'BOOLEAN',
    default: true,
    noBottomDivider: true
  },
  [FULLSCREEN.ALLOW_LINK]: {
    key: FULLSCREEN.ALLOW_LINK,
    title: 'Native_ProGallery_Expand_InfoSettings_WhatInfo_Link',
    type: 'BOOLEAN',
    default: false
  },
  [FULLSCREEN.WHEN_TO_SHOW_INFO]: {
    key: FULLSCREEN.WHEN_TO_SHOW_INFO,
    title: 'Native_ProGallery_Expand_InfoSettings_WhenInfo_Label',
    type: 'OPTIONS',
    controller: 'RADIO',
    thumbnailsSize: 'MEDIUM',
    default: 'ALWAYS',
    options: [{
      value: 'ALWAYS',
      title: 'Native_ProGallery_Expand_InfoSettings_WhenInfo_Always'
    }, {
      value: 'ON_TOGGLE',
      title: 'Native_ProGallery_Expand_InfoSettings_WhenInfo_Icon'
    }],
    description: 'Native_ProGallery_Expand_InfoSettings_WhenInfo_Tooltip'
  },
  [FULLSCREEN.EXPAND_INFO_POSITION]: {
    key: FULLSCREEN.EXPAND_INFO_POSITION,
    title: 'Native_ProGallery_Expand_InfoSettings_WhereInfo_Label',
    type: 'OPTIONS',
    default: 'SIDE',
    options: [{
      value: 'BOTTOM',
      title: 'Native_ProGallery_Expand_InfoSettings_WhereInfo_Bottom'
    }, {
      value: 'SIDE',
      title: 'Native_ProGallery_Expand_InfoSettings_WhereInfo_Side'
    }]
  },
  [FULLSCREEN.SHOW_INFO_BUTTON]: {
    key: FULLSCREEN.SHOW_INFO_BUTTON,
    title: 'MISSING_Toggle info',
    description: 'MISSING_Toggle info',
    type: 'BOOLEAN',
    default: false
  },
  [FULLSCREEN.ALLOW_FULLSCREEN_EXPAND]: {
    key: FULLSCREEN.ALLOW_FULLSCREEN_EXPAND,
    title: 'Native_ProGallery_Expand_ViewingSettings_FullScreen',
    description: 'Native_ProGallery_Expand_ViewingSettings_FullScreen_Tooltip',
    type: 'BOOLEAN',
    default: true
  },
  [FULLSCREEN.LOOP]: {
    key: FULLSCREEN.LOOP,
    title: 'Native_ProGallery_Expand_ViewingSettings_Loop',
    description: 'Native_ProGallery_Expand_ViewingSettings_Loop_Tooltip',
    type: 'BOOLEAN',
    default: false
  },
  [FULLSCREEN.ALLOW_MAGNIFY_IMAGE]: {
    key: FULLSCREEN.ALLOW_MAGNIFY_IMAGE,
    title: 'Native_ProGallery_Expand_ViewingSettings_Magnifying',
    description: 'Native_ProGallery_Expand_ViewingSettings_Magnifying_Tooltip',
    type: 'BOOLEAN',
    default: false
  },
  [FULLSCREEN.MAGNIFICATION_LEVEL]: {
    key: FULLSCREEN.MAGNIFICATION_LEVEL,
    title: 'Native_ProGallery_Expand_ViewingSettings_MagnifyingSize',
    description: 'MISSING_Magnification value',
    type: 'NUMBER',
    min: 1,
    max: 5,
    step: 1,
    default: 2
  },
  [FULLSCREEN.MAGNIFICATION_PERCENT]: {
    key: FULLSCREEN.MAGNIFICATION_PERCENT,
    title: 'Native_ProGallery_Expand_ViewingSettings_MagnifyingSize',
    type: 'NUMBER',
    min: 150,
    max: 500,
    step: 50,
    unit: 'percent',
    default: 200
  },
  [FULLSCREEN.BACKGROUND_BLUR_FILTER]: {
    key: FULLSCREEN.BACKGROUND_BLUR_FILTER,
    title: 'Native_ProGallery_Expand_BackgroundFilters_Blur',
    description: 'MISSING_Background blur filter',
    type: 'NUMBER',
    min: 1,
    max: 20,
    step: 1,
    default: 1
  },
  [FULLSCREEN.BACKGROUND_GRAYSCAL_EFILTER]: {
    key: FULLSCREEN.BACKGROUND_GRAYSCAL_EFILTER,
    title: 'Native_ProGallery_Expand_BackgroundFilters_Grayscale',
    description: 'MISSING_Background Grayscale filter',
    type: 'BOOLEAN',
    default: false
  },
  [FULLSCREEN.FULLSCREEN_PREVIEW]: {
    key: FULLSCREEN.FULLSCREEN_PREVIEW,
    title: 'Native_ProGallery_Expand_ExpandPreview_Header',
    type: 'VIEWPORT',
    default: '',
    component: 'FULLSCREEN'
  },
  [FULLSCREEN.FULLSCREEN_CTA]: {
    key: FULLSCREEN.FULLSCREEN_CTA,
    title: 'Customize Expand',
    type: 'FULLSCREEN_PREVIEW_CTA',
    default: '',
    isExperimental: true
  }
};
//# sourceMappingURL=fullscreen.js.map